/**
 * Identifier helpers.
 *
 * IDs are strings everywhere, including in MySQL (VARCHAR(36) primary keys
 * rather than AUTO_INCREMENT) specifically so Firestore IDs survive the
 * migration unchanged. See docs/MIGRATION-50K.md.
 */

/** Random id for new records and optimistic local inserts. */
export function newId() {
  if (globalThis.crypto?.randomUUID) return globalThis.crypto.randomUUID()
  // Older browsers, and any non-secure context
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = (Math.random() * 16) | 0
    const v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

/**
 * Deterministic id for a direct chat between two users.
 *
 * Sorting the two ids means both people compute the same value, so two users
 * opening the conversation at the same moment cannot create two chats.
 */
export function directChatId(userIdA, userIdB) {
  return [userIdA, userIdB].sort().join('_')
}

/** Temporary client-side id for a message that has not reached the server. */
export function tempMessageId() {
  return `temp_${newId()}`
}

export function isTempId(id) {
  return typeof id === 'string' && id.startsWith('temp_')
}
